import React from 'react';
import ProspectList from '../components/partner-network/ProspectList';

const PartnerProspectsPage: React.FC = () => <ProspectList />;

export default PartnerProspectsPage;
